export enum TabSlugOptions {
  preferences = 'preferences',
  manageLinks = 'manageLinks',
}

export enum WorkflowTabSlugOptions {
  accounts = 'accounts',
  manageLinks = 'manageLinks',
}

export type TabSlug = keyof typeof TabSlugOptions;
